export enum DropdownPlacement {
	BOTTOM = 'bottom',
	LEFT = 'left',
	RIGHT = 'right',
}
